module.exports = __webpack_public_path__ + "static/fonts/flaming/OpenSans-Medium.ttf";